import { useEffect, useState } from 'react';
import '../css/MemoryGame.css';
import PLsoccerLogos from '../assets/PLsoccerLogos';

const SoccerMemory = () => {
    const soccerLogos = [
        { name: 'Arsenal', logo: PLsoccerLogos["Arsenal"] },
        { name: 'Aston Villa', logo: PLsoccerLogos["Aston Villa"] },
        { name: 'Bournemouth', logo: PLsoccerLogos["Bournemouth"] },
        { name: 'Brentford', logo: PLsoccerLogos["Brentford"] },
        { name: 'Brighton & Hove Albion', logo: PLsoccerLogos["Brighton & Hove Albion"] },
        { name: 'Burnley', logo: PLsoccerLogos["Burnley"] },
        { name: 'Chelsea', logo: PLsoccerLogos["Chelsea"] },
        { name: 'Crystal Palace', logo: PLsoccerLogos["Crystal Palace"] },
        { name: 'Everton', logo: PLsoccerLogos["Everton"] },
        { name: 'Fulham', logo: PLsoccerLogos["Fulham"] },
        { name: 'Leeds United', logo: PLsoccerLogos["Leeds United"] },
        { name: 'Liverpool', logo: PLsoccerLogos["Liverpool"] },
        { name: 'Manchester City', logo: PLsoccerLogos["Manchester City"] },
        { name: 'Manchester United', logo: PLsoccerLogos["Manchester United"] },
        { name: 'Newcastle United', logo: PLsoccerLogos["Newcastle United"] },
        { name: 'Nottingham Forest', logo: PLsoccerLogos["Nottingham Forest"] },
        { name: 'Sunderland', logo: PLsoccerLogos["Sunderland"] },
        { name: 'Tottenham Hotspur', logo: PLsoccerLogos["Tottenham Hotspur"] },
        { name: 'West Ham United', logo: PLsoccerLogos["West Ham United"] },
        { name: 'Wolverhampton Wanderers', logo: PLsoccerLogos["Wolverhampton Wanderers"] }
    ];

    // make the deck based on the board size
    const buildDeck = (size) => {
        const totalCards = size * size;
        const pairCount = totalCards / 2;
        const pickedLogos = soccerLogos.slice(0, pairCount);

        const fullDeck = [...pickedLogos, ...pickedLogos].map((team, index) => ({
            id: `${team.name}-${index}`,
            name: team.name,
            logo: team.logo
        }));

        const shuffledDeck = [...fullDeck];

        for (let i = shuffledDeck.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            const temp = shuffledDeck[i];
            shuffledDeck[i] = shuffledDeck[randomIndex];
            shuffledDeck[randomIndex] = temp;
        }

        return shuffledDeck;
    };

    const [boardSize, setBoardSize] = useState(4);
    const [cards, setCards] = useState(buildDeck(4));
    const [flippedCards, setFlippedCards] = useState([]);
    const [matchedCards, setMatchedCards] = useState([]);
    const [moves, setMoves] = useState(0);
    const [gameWon, setGameWon] = useState(false);
    const [isChecking, setIsChecking] = useState(false);


    // start or restart the game
    const startGame = (size = boardSize) => {
        setCards(buildDeck(size));
        setFlippedCards([]);
        setMatchedCards([]);
        setMoves(0);
        setGameWon(false);
        setIsChecking(false);
    };

    useEffect(() => {
        if (cards.length > 0 && matchedCards.length === cards.length) {
            setGameWon(true);
        }
    }, [matchedCards, cards]);

    // flip the card when user clicks it
    const handleCardClick = (card) => {
        if (isChecking) return;
        if (matchedCards.includes(card.id)) return;
        if (flippedCards.find((item) => item.id === card.id)) return;
        if (flippedCards.length === 2) return;

        const newFlippedCards = [...flippedCards, card];
        setFlippedCards(newFlippedCards);

        // once 2 cards are flipped, check if they match
        if (newFlippedCards.length === 2) {
            setMoves((prev) => prev + 1);
            setIsChecking(true);

            if (newFlippedCards[0].name === newFlippedCards[1].name) {
                setTimeout(() => {
                    setMatchedCards((prev) => [
                        ...prev,
                        newFlippedCards[0].id,
                        newFlippedCards[1].id
                    ]);
                    setFlippedCards([]);
                    setIsChecking(false);
                }, 500);
            } else {
                setTimeout(() => {
                    setFlippedCards([]);
                    setIsChecking(false);
                }, 850);
            }
        }
    };

    const cardIsFlipped = (card) => {
        return matchedCards.includes(card.id) || flippedCards.find((item) => item.id === card.id);
    };

    return (
        <main className="memory-page">
            <section className="memory-top-box">
                <h1> Memory Game: Premier League</h1>
                <p>Match all of the Premier League logos to its match.</p>

                <div className="memory-controls">
                    <label htmlFor="soccer-board-size">Board Size:</label>
                    <select
                        id="soccer-board-size"
                        className="memory-select"
                        value={boardSize}
                        onChange={(e) => {
                            const newSize = Number(e.target.value);
                            setBoardSize(newSize);
                            startGame(newSize);
                        }}
                    >
                        <option value={4}>4 x 4</option>
                        <option value={6}>6 x 6</option>
                    </select>

                    <button
                        type="button"
                        className="memory-btn"
                        onClick={() => startGame(boardSize)}
                    >
                        Play Again
                    </button>
                </div>

                <div className="memory-stats">
                    <span>Moves: {moves}</span>
                    <span>Matches: {matchedCards.length / 2}</span>
                </div>

                {gameWon && (
                    <p className="memory-win">
                        You matched them all in {moves} moves!
                    </p>
                )}
            </section>

            <section className="memory-board-box">
                <div className={`memory-grid grid-${boardSize}`}>
                    {cards.map((card) => (
                        <button
                            key={card.id}
                            type="button"
                            className={`memory-card size-${boardSize} ${cardIsFlipped(card) ? 'flipped' : ''} ${matchedCards.includes(card.id) ? 'matched' : ''}`}
                            onClick={() => handleCardClick(card)}
                        >
                            <div className="memory-card-inner">
                                <div className="memory-card-front"></div>
                                <div className="memory-card-back">
                                    <img src={card.logo} alt={card.name} />
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </section>
        </main>
    );
};

export default SoccerMemory;